import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-point",
  "use": "icon-point-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-point\">\n<path d=\"M8.00024 10L11.6667 14.251H4.3338L8.00024 10Z\" fill=\"#1677FF\" />\n<path d=\"M8.00024 6L4.3338 1.74902L11.6667 1.74902L8.00024 6Z\" fill=\"#1677FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol